(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("monthly", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/subscription/types/monthlyView.html",
            controller: ["subscriptionResource", "messageService", "currencyService", MonthlyCtrl],
            controllerAs: "vm"
        };
        function MonthlyCtrl(subscriptionResource, messageService, currencyService) {
            var vm = this;
            vm.loading = true;
            subscriptionResource.getSubscriptionViewModel(function (result) {
                vm.subscription = result;
                vm.currencySymbol = currencyService.find(vm.subscription.currencyCode).symbol;
                vm.loading = false;
            }, function (error) {
                messageService.error(error);
            });
        }
    });
}());
